import { breakpoints } from '@mq';
import { isBrowser } from '@utils';

export default isBrowser && window.matchMedia(`(max-width: ${breakpoints.small - 0.01}em)`).matches;
